<template>
  <v-layout align-center justify-center fill-height style="background: white;">
    <p-snackbar></p-snackbar>
    <v-flex xs12 sm10 md8 lg5>
      <!-- // Card inicial para mostrar o carregamento do fomrulário -->
      <v-card v-if="loadingFields" class="pa-4 pb-0 elevation-7 rounded-card">
        <v-progress-linear indeterminate></v-progress-linear>
        <a v-if="checkIsFree" href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
          <v-layout align-center justify-center row fill-height>
              <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
          </v-layout>
        </a>
      </v-card>
      <!-- // Card mostrado apos enviar o formulário -->
      <div v-else-if="formSended">
        <v-card class="pa-4 pb-0 elevation-7 rounded-card">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <span class="display-1">Obrigado!</span>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <img width="150" height="150" src="https://app.api.illis.com.br/images/certinho_form.png" alt="certinho">
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <span class="headline">Sua solicitação foi enviada com sucesso!</span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="returnForm()">Enviar outro formulário</v-btn>
          </v-card-actions>
          <!-- <a href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
            <v-layout align-center justify-center row fill-height>
                <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
            </v-layout>
          </a> -->
        </v-card>
        <v-card class="pa-3 pb-0 mt-2 elevation-7 rounded-card">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <span style="font-size: 16px!important;font-weight: 500;">Você também pode criar seus próprios formulários de forma gratuita!</span>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                  <v-layout align-center justify-center row fill-height>
                      <v-btn small href="https://illis.com.br/features/?utm_source=illis&utm_medium=form&utm_campaign=form&utm_content=form&utm_term=formul%C3%A1rio#formulario" target="_blank" outline color="primary">Saiba mais</v-btn>
                  </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <a v-if="checkIsFree" href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
            <v-layout align-center justify-center row fill-height>
                <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
            </v-layout>
          </a>
        </v-card>
      </div>
      <!-- // Card caso o formulário não exista -->
      <v-card v-else-if="formNotFound" class="pa-4 pb-0 elevation-7 rounded-card">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <span class="headline">Fomulário não encontrado</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <!-- // Card que mostra o conteudo do fomulário -->
      <v-card v-else class="pa-4 pb-0 elevation-7 rounded-card">
        <v-layout align-center justify-center row wrap>
          <v-flex shrink v-if="formInfo.logo_path && !checkIsFree">
            <div class="p-white text-xs-center">
              <!-- <v-avatar size="150px" v-ripple v-if="!formInfo.logo_path" class="grey lighten-3">
                <img :src="`https://illis.com.br/wp-content/uploads/2021/07/Nova_logo_illis.svg`" alt="avatar">
              </v-avatar> -->
              <v-avatar size="150px" v-ripple>
                <img :src="`${basePath}uploads/forms/${formInfo.logo_path}`" alt="avatar">
              </v-avatar>
            </div>
          </v-flex>
          <v-flex grow>
            <v-flex xs12 text-xs-center>
              <span class="display-1">{{formInfo.id_text}}</span>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <span class="subheading">{{formInfo.description}}</span>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-card-text>
        <!-- <v-card-text class="pa-0" style="overflow-y: auto; overflow-x: hidden; min-height: 80%;"> -->
          <v-form ref="form_form">
            <div v-for="(field, index) in formCustomFields" :key="index">
              <!--//-------------------------campo INTEGER---------------------->
              <v-flex class="flex-custom-field" v-if="field['custom_field_opt']['type'] === 'number'">
                <v-text-field type="number" :id="'ff_' + field['custom_field_opt']['id']" :label="getLabel(field['custom_field_opt']['title'], field['required'])" v-model="editedItem['fields'][field['custom_field_id']]" @keyup.enter.exact="save()" validate-on-blur :rules="field['required'] ? requiredRule(field['custom_field_opt']['title'],190) : []"></v-text-field>
              </v-flex>
              <!--//-------------------------campo VALUE---------------------->
              <v-flex class="flex-custom-field" v-else-if="field['custom_field_opt']['type'] === 'value'">
                <p-money :id="'ff_' + field['custom_field_opt']['id']" :label="getLabel(field['custom_field_opt']['title'], field['required'])" v-model="editedItem['fields'][field['custom_field_id']]" @keyupEnter="save()" validate-on-blur :rules="field['required'] ? requiredRuleValue(field['custom_field_opt']['title']) : []"/>
              </v-flex>
              <!--//-------------------------campo STRING---------------------->
              <v-flex class="flex-custom-field" v-else-if="['string', 'email', 'phone'].includes(field['custom_field_opt']['type'])">
                <v-text-field :id="'ff_' + field['custom_field_opt']['id']" :label="getLabel(field['custom_field_opt']['title'], field['required'])" v-model="editedItem['fields'][field['custom_field_id']]" @keyup.enter.exact="save()" :mask="getMaskField(field['custom_field_opt']['type'])" validate-on-blur :rules="getRuleField(field['custom_field_opt']['type'], field['custom_field_opt']['title'], field['required'])">
                </v-text-field>
              </v-flex>
              <!--//-------------------------campo SELECT---------------------->
              <v-flex class="flex-custom-field" v-else-if="field['custom_field_opt']['type'] === 'select'">
                <!-- // itemsProps quando for inclusão de tarefa modelo, pega as opções que foram inseridas para mostrar apenas elas -->
                <p-select :id="'ff_' + field['custom_field_opt']['id']" entity="custom_field" :label="getLabel(field['custom_field_opt']['title'], field['required'])" clearable v-model="editedItem['fields'][field['custom_field_id']]" @keyup.enter.exact="save()" :itemsProps="field['custom_field_opt']['custom_field_options']" @close="fieldEditing['ff_' + field['custom_field_opt']['id']] = false" validate-on-blur :rules="field['required'] ? requiredRule(field['custom_field_opt']['title']) : []"></p-select>
              </v-flex>
              <!--//-------------------------campo MULTISELECT---------------------->
              <v-flex class="flex-custom-field" v-else-if="field['custom_field_opt']['type'] === 'multiselect'">
                <!-- // itemsProps quando for inclusão de tarefa modelo, pega as opções que foram inseridas para mostrar apenas elas -->
                <p-select multiple :id="'ff_' + field['custom_field_opt']['id']" entity="custom_field" :label="getLabel(field['custom_field_opt']['title'], field['required'])" clearable :value="editedItem['fields'][field['custom_field_id']] ? editedItem['fields'][field['custom_field_id']].split(',').map(Number) : null" @input="(val) => {editedItem['fields'][field['custom_field_id']] = val.toString()}" @keyup.enter.exact="save()" :itemsProps="field['custom_field_opt']['custom_field_options']" @close="fieldEditing['ff_' + field['custom_field_opt']['id']] = false" validate-on-blur :rules="field['required'] ? requiredRule(field['custom_field_opt']['title']) : []"></p-select>
              </v-flex>
              <!--//-------------------------campo DATE---------------------->
              <v-flex class="flex-custom-field" v-else-if="field['custom_field_opt']['type'] === 'date'">
                  <p-date :component_id="'ff_' + field['custom_field_opt']['id']" :label="getLabel(field['custom_field_opt']['title'], field['required'])" v-model="editedItem['fields'][field['custom_field_id']]" @keyupEnter="save()" validate-on-blur :rules="field['required'] ? requiredRule(field['custom_field_opt']['title']) : []"></p-date>
              </v-flex>
              <!--//-------------------------campo FILE---------------------->
              <v-flex class="flex-custom-field" v-else-if="field['custom_field_opt']['type'] === 'files'">
                  <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                  <!-- // editedItem['planHaveMemory'] verifica se o plano da empresa do formulário, ainda possui espaço para adicionar arquivos -->
                  <p-file :id="'ff_' + field['custom_field_id']" :ref="'PFile_' + field['custom_field_id']" :label="getLabel(field['custom_field_opt']['title'], field['required'])" :disabled="!planHaveMemory" @keyupEnter="save()" :required="field['required']" validate-on-blur :rules="field['required'] ? requiredManyRule(field['custom_field_opt']['title']) : []" :custom_field_id="field['custom_field_id']" @addFiles="(val)=>addFiles(val, field['custom_field_opt'])">
                  </p-file>
              </v-flex>
            </div>
            <small>* indica campos obrigatórios</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-center row fill-height>
            <v-btn color="primary" large :loading="loadingSended" :disabled="loadingSended" @click="save()">Enviar</v-btn>
          </v-layout>
        </v-card-actions>
        <a v-if="checkIsFree" href="https://www.illis.com.br" target="_blank" style="text-decoration:none!important;color:#7a7d7e;">
          <v-layout align-center justify-center row fill-height>
              <span >powered by</span>&nbsp;<img width="45" height="30" src="https://illis.com.br/wp-content/uploads/2021/08/Ativo-1-150x100.png">
          </v-layout>
        </a>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  /* eslint-disable eqeqeq, no-useless-escape */
  import PSnackbar from './shared/PSnackbar'
  import PSelect from './shared/PSelect'
  import PDate from './shared/PDate'
  import PFile from './shared/PFile'
  import PMoney from './shared/PMoney'
  import methodTaskSocket from './../mixin/methodTaskSocket'
  import rules from './../mixin/rules'
  export default ({
    mixins: [methodTaskSocket, rules],
    components: {PSnackbar, PSelect, PDate, PFile, PMoney},
    data: () => ({
      formCustomFields: [],
      // defaultFormCustomFields: [],
      basePath: process.env.API,
      loadingSended: false,
      loadingFields: false,
      formSended: false,
      checkIsFree: false,
      planHaveMemory: false,
      // armazena o id da empresa do formulário
      companyId: 0,
      editedItem: {tasktemplate_id: 0, form_id: 0, fields: {}},
      formInfo: {id_text: '', description: '', logo_path: ''},
      moneyOptions: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      formNotFound: false
    }),
    created () {
      if (this.$route.params.id) { // Quando entra na tarefa pelo link sem ser compartilhado
        this.selectForm(this.$route.params.id)
      } else {
        this.formNotFound = true
      }
    },
    methods: {
      selectForm (formId) {
        this.loadingFields = true
        this.$http.get(`api/form_view/${formId}`).then((res) => {
          this.formCustomFields = res.body['form_custom_fields_opt']
          this.companyId = res.body['company_id']
          // Busca se a empresa está em um plano pago ou não
          this.checkIsFree = res.body['checkIsFree']
          // verifica se a empresa ainda possui memoria para adicionar arquivos
          this.planHaveMemory = res.body['planHaveMemory']
          // this.defaultFormCustomFields = JSON.parse(JSON.stringify(res.body['form_custom_fields_opt']))
          // inclui os valores dos campos no vueX customField para que seja usado no PFile
          // inclui o files pois é necessário nos campos de arquivos
          let customFields = this.formCustomFields.map(formCustomField => { return Object.assign({files: []}, formCustomField['custom_field_opt']) })
          this.$store.commit('customField/change_values', customFields)
          this.editedItem['tasktemplate_id'] = res.body['tasktemplate_id']
          this.editedItem['form_id'] = res.body['id']
          Object.assign(this.formInfo, {id_text: res.body['id_text'], description: res.body['description'], logo_path: res.body['logo_path']})
          this.loadingFields = false
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar o formulário, reporte o erro.', color: 'error', dialog: true})
          this.formNotFound = true
          this.loadingFields = false
        })
      },
      save () {
        this.loadingSended = true
        if (this.$refs.form_form && !this.$refs.form_form.validate()) {
          this.formCustomFields.forEach(formCustomField => {
            if (formCustomField['custom_field_opt']['type'] === 'files') {
              let pfile = this.$refs[`PFile_${formCustomField['custom_field_id']}`]
              if (pfile) pfile[0].checkRequired()
            }
          })
          this.loadingSended = false
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.$http.post('api/form_send', this.editedItem).then((res) => {
          this.$store.dispatch('customField/add_files', {task_id: res.body['id'], save_bd: true}).then((files) => {
            // Metodo para adicionar tarefas por socket em todos os lugares necessários
            this.methodAddTaskSocket(res.body)
            if (Array.isArray(files)) {
              files.forEach(file => {
                if (file['error']) {
                  // incluido o settimeout pois primeiro manda a msg de que o formulário foi salvo com sucesso
                  setTimeout(() => {
                    this.$store.commit('snackbar/change_values', { text: 'Não foi possível enviar um dos arquivos', color: 'error', dialog: true })
                  }, 2500)
                } else {
                  // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
                  file['source'] = 2
                  // Emitindo evento para adicionar arquivo à tela de arquivos
                  this.$socket.emit('generalEvent', {
                    data: file,
                    responseEvent: 'addSocketItem',
                    room: `files${file['company_id']}`
                  })
                }
              })
            }
            this.formSended = true
            this.$store.commit('snackbar/change_values', {
              text: 'Fomulário enviado com sucesso!',
              color: 'success',
              timeout: 2000,
              dialog: true
            })
            this.loadingSended = false
          }, err => {
            console.log(err)
            this.formSended = true
            this.loadingSended = false
            this.$store.commit('snackbar/change_values', { text: `Formulário enviado com sucesso! Porém ocorreu um erro ao salvar os arquivos!`, color: 'error', dialog: true, timeout: 10000 })
            this.$store.commit('loader/change_dialog', false)
          })
        }, err => {
          console.log(err)
          this.loadingSended = false
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível incluir o formulário, verifique se o formulário existe.',
            color: 'error',
            dialog: true
          })
        })
      },
      addFiles (files, field) {
        let values = {
          'custom_field_id': field['id'],
          'save_bd': false,
          'task_id': this.task_id,
          // caso tenha usuário logado e seja da mesma empresa, então adiciona o usuário como responsável do arquivo, caso contrario vai sem usuário
          'user_id': this.$auth.check() ? (this.$auth.user().company_id == this.companyId ? this.$auth.user().id : '') : '',
          'company_id': this.companyId,
          'connection_company_id': this.companyId,
          'files': files
        }
        // Adiciona o id do campo personalizado para saber diferenciar no momento de salvar
        this.$store.dispatch('customField/add_files', values)
      },
      returnForm () {
        // atualiza a página para zerar todos os campos, principalmente o de arquivos
        location.reload()
      },
      getLabel (label = 'Campo', required = false) {
        return label + (required ? '*' : '')
      },
      getRuleField (type, name, required) {
        switch (type) {
          case 'email':
            return this.emailRule(name, false, required)
          default:
            return required ? this.requiredRule(name, 190) : []
        }
      },
      getMaskField (type) {
        switch (type) {
          case 'phone':
            return '(##) #####-####'
          default:
            return null
        }
      }
    }
  })
</script>

<style scoped>
  .rounded-card{
    border-radius:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FormView.vue